/* import __COLOCATED_TEMPLATE__ from './dropdown-select-box-header.hbs.js'; */
import { computed } from "@ember/object";
import { readOnly } from "@ember/object/computed";
import { classNameBindings, classNames } from "@ember-decorators/component";
import SingleSelectHeaderComponent from "select-kit/components/select-kit/single-select-header";
const DropdownSelectBoxHeader = dt7948.c(class DropdownSelectBoxHeader extends SingleSelectHeaderComponent {
  static {
    dt7948.g(this.prototype, "showFullTitle", [readOnly("selectKit.options.showFullTitle")]);
  }
  #showFullTitle = (dt7948.i(this, "showFullTitle"), void 0);
  static {
    dt7948.g(this.prototype, "customStyle", [readOnly("selectKit.options.customStyle")]);
  }
  #customStyle = (dt7948.i(this, "customStyle"), void 0);
  static {
    dt7948.g(this.prototype, "btnCustomClasses", [readOnly("selectKit.options.btnCustomClasses")]);
  }
  #btnCustomClasses = (dt7948.i(this, "btnCustomClasses"), void 0);
  static {
    dt7948.g(this.prototype, "caretUpIcon", [readOnly("selectKit.options.caretUpIcon")]);
  }
  #caretUpIcon = (dt7948.i(this, "caretUpIcon"), void 0);
  static {
    dt7948.g(this.prototype, "caretDownIcon", [readOnly("selectKit.options.caretDownIcon")]);
  }
  #caretDownIcon = (dt7948.i(this, "caretDownIcon"), void 0);
  get btnClassName() {
    return `btn ${this.showFullTitle ? "btn-icon-text" : "no-text btn-icon"}`;
  }
  static {
    dt7948.n(this.prototype, "btnClassName", [computed("showFullTitle")]);
  }
  get btnStyleClass() {
    return `${this.customStyle ? "" : "btn-default"}`;
  }
  static {
    dt7948.n(this.prototype, "btnStyleClass", [computed("customStyle")]);
  }
  get caretIcon() {
    return this.selectKit.isExpanded ? this.caretUpIcon : this.caretDownIcon;
  }
  static {
    dt7948.n(this.prototype, "caretIcon", [computed("selectKit.isExpanded", "caretUpIcon", "caretDownIcon")]);
  }
}, [classNameBindings("btnClassName", "btnStyleClass", "btnCustomClasses"), classNames("dropdown-select-box-header")]);
export default DropdownSelectBoxHeader;